<template>
  <div
    class="section section-signup"
    :style="
      'background-image: url(' +
        myTheme.home_section_background_image +
        '); background-size: cover; background-position: top center; min-height: 700px;'
    "
    v-loading.fullscreen.lock="isLoading"
    element-loading-background="rgba(256, 256, 256, 0.6)"
  >
    <div class="dark-overlay"></div>
    <!--b-alert
      id="success-popup"
      v-model="showSuccess"
      variant="success"
      class="alert alert-success"
      role="alert"
    >
      <div class="container">
        <div class="alert-icon">
          <i class="now-ui-icons ui-2_like"></i>
        </div>
        <strong>Password Reset Link Sent to {{ this.email }}</strong> please
        check your emails
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
    </b-alert-->

    <b-alert v-model="showError" variant="danger" dismissible>
      {{$t('validation.provide_valid_email')}}
    </b-alert>
    <div class="row">
      <cards
        class="card-signup"
        style="margin-top:50px"
        header-classes="text-center"
        :style="{ color: myTheme.topMenu.normal.color }"
      >
        <template slot="header">
          <h3 class="card-title title-up">{{ $t('text.forgotten_password_message_1') }}</h3>
          <h4>{{ $t('text.forgotten_password_message_2') }}</h4>
          <h4>{{ $t('text.forgotten_password_message_3') }}</h4>
          <div class="social-line"></div>
        </template>
        <template>
          <ValidationProvider rules="required|email" v-slot="{ errors }">
            <fg-input
              type="email"
              ref="email"
              id="email"
              v-model.lazy="email"
              class="no-border "
              :placeholder="$t('input.placeholder.email')"
              :error="errors[0]"
              inputClasses="white-input"
            >
            </fg-input>
          </ValidationProvider>
        </template>
        <div class="text-center">
          <n-button
            type="primary"
            class="btn btn-primary btn-round"
            v-bind:style="myTheme.customizeButton"
            :disabled="!isComplete"
            @click="newPasswordRequest()"
          >
            {{ isComplete ? $t('button.send_reset_email') : $t('button.enter_your_email') }}
            <i v-if="isComplete" class="now-ui-icons ui-1_send"></i>
          </n-button>
        </div>
      </cards>
    </div>
  </div>
</template>

<script>
import { FormGroupInput, Button, Cards } from "@/components";
import { mapGetters } from "vuex";
import { ValidationProvider } from "vee-validate";
import { helpers } from "@/utilities";

export default {
  name:'forgotten-password',
  computed: {
    ...mapGetters(["isAuthenticated"]),
    isComplete() {
      return this.email;
    }
  },
  components: {
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
    ValidationProvider,
    Cards,
  },
  bodyClass: "forgotten-password-page",
  data() {
    return {
      getHelpers: helpers,
      email: "",
      showError: false,
      errors: [],
      isLoading: false
    };
  },
  methods: {
    newPasswordRequest() {
      this.isLoading = true;
      this.forgotPasswordRequest(this.email)
        .then((response) => {
          this.isLoading = false;  

          if (!response.data.success) {
              helpers.showErrorMessageAlert(
                helpers.getMessageFromAPIError(response.data)
              );
              return;
          }
          
          //--- display mesage email sent
          let alert_options = {
            html: true,
            okText: this.$t('button.ok'),
            animation: "fade",
            type: "basic",
            backdropClose: false,
            customClass: "confirm"
          };

          let alert_message =
            "<div><i class='k-icon-location-1 big-icon' style='color:" +
            this.staticColor.ratingOkey +
            "' ></i></div>";
          alert_message +=
            `<div class='dg-content-body-text'>${this.$t('text.forgotten_password_message')}</div>`;
          this.$dialog.alert(alert_message, alert_options);
        })
        .catch((e) => {
          this.captureException(e)
          this.showError = true;
          this.isLoading = false;
          setTimeout(() => {
            this.showError = false;
            this.errors.push;
          }, 5000);
        });
    }
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$router.push("/");
    }
  }
};
</script>
<style scoped>
.forgotten-password-page .alert {
  position: fixed;
  width: 100%;
  z-index: 997;
  margin-top: 62px;
}
</style>
